import * as actions from '../actions/actionTypes'
import { IPhasesState, IState } from '../store/state';

const phases = (state : IPhasesState = {}, action:any) : IPhasesState => {
  switch (action.type) {
    case actions.FETCH_PHASES_SUCCEEDED:
      return Object.assign({}, state, action.data.phases)
    default:
      return state
  }
}

// fetch data describing all phases
/*
  returns an object containing data according to each phase
    id:     int,
    length: int,
    name:   string,
    phase_type:{ id: int, name: string },
    phase_type_nr: int
 */
export const getPhases = (state:IState) => {
  return Object.keys(state.phases).map( (key:any) => state.phases[key] )
}

// fetch phase information depending on a certain id
/*
  returns an object containing data according to a specific  phase
    id:     int,
    length: int,
    name:   string,
    phase_type:{ id: int, name: string },
    phase_type_nr: int
*/
export const getPhasesById = (state:IState, id:number) => {
  return getPhases(state).find((phase:any) => phase.id === id)
}

// fetch phase name depending on a certain id
/*
  returns a plain string
*/
export const getPhasesNameById = (state:IState, id:number) => {
  return getPhasesById(state, id).name
}
export default phases
